import { 
    getV730iPatientHistoryGraphDataAPI, 
    getV730iPatientHistoryCursorDataAPI, 
    getV730iPatientHistoryPatientModeAPDataAPI, 
    getV730iPatientHistoryEventHistoryDataAPI, 
    getV730iPatientHistoryLiveAlarmHistoryDataAPI,
    getV730iPatientHistoryAdditionalFeaturesHistoryDataAPI,
    getNX5PatientHistoryGraphDataAPI,
    getNX5PatientHistoryCursorDataAPI,
    getNX5PatientHistoryLiveAlarmHistoryDataAPI,
    getNX5PatientHistoryMonitorParameterHistoryDataAPI,
    getNX5PatientHistoryTabularTrendDataAPI
} from "../adapter/cms-adapter";

export const getV730iPatientHistoryGraphData = (data) => {

    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryGraphDataAPI(reqData).then((res) => {

            if (res && res?.data && res.data?.data) resolve(res.data.data);
            else reject("Error in getV730iPatientHistoryGraphData");
        })
    })

    return promise;
}

export const getV730iPatientHistoryCursorData = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryCursorDataAPI(reqData).then((res) => {

            if (res && res?.data) resolve(res.data);
            else reject("Error in getV730iPatientHistoryCursorData");
        })
    })

    return promise;
}

export const getV730iPatientHistoryPatientModeAPData = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryPatientModeAPDataAPI(reqData).then((res) => {

            if (res && res?.data) resolve(res.data);
            else reject("Error in getV730iPatientHistoryPatientModeAPDataAPI");
        })
    })

    return promise;
}

export const getV730iPatientHistoryEventHistoryData = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryEventHistoryDataAPI(reqData).then((res) => {

            if (res && res?.data) resolve(res.data);
            else reject("Error in getV730iPatientHistoryEventHistoryDataAPI");
        })
    })

    return promise;
}

export const getV730iPatientHistoryLiveAlarmHistoryData = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryLiveAlarmHistoryDataAPI(reqData).then((res) => {

            if (res && res?.data) resolve(res.data);
            else reject("Error in getV730iPatientHistoryLiveAlarmHistoryData");
        })
    })

    return promise;
}

export const getV730iPatientHistoryAdditionalFeaturesHistoryData = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {

        getV730iPatientHistoryAdditionalFeaturesHistoryDataAPI(reqData).then((res) => {

            if (res && res?.data) resolve(res.data);
            else reject("Error in getV730iPatientHistoryAdditionalFeaturesHistoryData");
        })
    })

    return promise;
}


export const getNX5PatientHistoryGraphData = (data) => {
    let reqData = data;
    let promise = new Promise(function (resolve, reject) {
        getNX5PatientHistoryGraphDataAPI(reqData).then((res) => {
            if (res && res?.data) resolve(res.data.data);
            else reject("Error in getNX5PatientHistoryGraphData");
        })
    })

    return promise;
}

export const getNX5PatientHistoryCursorData = (data) => {
    let reqData = data;
    let promise = new Promise(function (resolve, reject) {
        getNX5PatientHistoryCursorDataAPI(reqData).then((res) => {
            if (res && res?.data) resolve(res.data);
            else reject("Error in getNX5PatientHistoryCursorData");
        })
    })

    return promise;
}

export const getNX5PatientHistoryLiveAlarmHistoryData = (data) => {
    return new Promise((resolve, reject) => {
        getNX5PatientHistoryLiveAlarmHistoryDataAPI(data)
            .then((res) => {
                if (res && res?.data) {
                    resolve(res.data);
                } else {
                    reject(new Error("Error in getNX5PatientHistoryLiveAlarmHistoryData"));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getNX5PatientHistoryMonitorParameterHistoryData = (data) => {
    return new Promise((resolve, reject) => {
        getNX5PatientHistoryMonitorParameterHistoryDataAPI(data)
            .then((res) => {
                if (res && res?.data) {
                    resolve(res.data);
                } else {
                    reject(new Error("Error in getNX5PatientHistoryMonitorParameterHistoryData"));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};